import { render, staticRenderFns } from "./baseVideo.vue?vue&type=template&id=6fd5af0e&scoped=true"
import script from "./baseVideo.vue?vue&type=script&lang=js"
export * from "./baseVideo.vue?vue&type=script&lang=js"
import style0 from "./baseVideo.vue?vue&type=style&index=0&id=6fd5af0e&prod&scoped=true&lang=css"
import style1 from "./baseVideo.vue?vue&type=style&index=1&id=6fd5af0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd5af0e",
  null
  
)

export default component.exports